import { Typography, useTheme } from '@mui/material';
import React from 'react';
import { Text, TextField } from '@sitecore-jss/sitecore-jss-nextjs';

enum HeadingSize {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

enum ColorValue {
  primary = 'primary',
  secondary = 'secondary',
  black = 'black',
  white = 'white',
}

type ColorValueType = keyof typeof ColorValue;
type TextAlign = 'left' | 'center' | 'right';

type Props = {
  children?: TextField | string | React.ReactNode;
  align?: TextAlign;
  size?: keyof typeof HeadingSize;
  color?: ColorValueType;
  styles?: Pick<React.CSSProperties, 'lineHeight' | 'color' | 'fontSize' | 'fontWeight'>;
  id?: string;
  className?: string;
  isChildren?: boolean;
};

function UiHeading({ size, color, align, styles, isChildren, children, ...rest }: Props) {
  const theme = useTheme();

  function getColor(color?: ColorValueType) {
    if (styles?.color) {
      return styles.color;
    }

    switch (color) {
      case ColorValue.primary:
        return theme.palette.themeColor.main;
      case ColorValue.secondary:
        return theme.palette.themeColor.contrastText;
      case ColorValue.black:
        return theme.palette.black.main;
      case ColorValue.white:
        return theme.palette.white.main;
    }
    return;
  }

  return (
    <Typography
      variant={HeadingSize[size]}
      sx={{ ...styles, textAlign: align, color: getColor(color) }}
      {...rest}
    >
      {typeof children === 'string' || isChildren ? (
        children
      ) : (
        <Text field={children as TextField}></Text>
      )}
    </Typography>
  );
}

export default UiHeading;
